class MenuDrawer extends Theme.Drawer {
  connectedCallback() {
    super.connectedCallback();

    this.addDirectEvent("menulink:click", document, () => {
      this.show();
    });
  }

  hide() {
    super.hide();
    const activeSubmenu = this.querySelector(".submenu.state--active");
    if (activeSubmenu) activeSubmenu.classList.remove("state--active");
  }

  showSubmenu(detail, element) {
    const parent = element.closest(".multilink-menu");
    const submenu = parent.querySelector(".submenu");
    if (submenu) submenu.classList.add("state--active");
  }

  hideSubmenu(detail, element) {
    const submenu = element.closest(".submenu");
    if (submenu) submenu.classList.remove("state--active");
  }

}

customElements.define("menu-drawer", MenuDrawer);

class MenuOverlay extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("menu-drawer").hide();
    });
  }
}

customElements.define("menu-overlay", MenuOverlay);


class MenuClose extends HTMLElement {
  constructor() {
    super();

    this.addEventListener("click", (event) => {
      event.preventDefault();
      this.closest("menu-drawer").hide();
    });
  }
}

customElements.define("menu-close", MenuClose);
